import { ethers } from 'ethers';  
import {Wallet} from 'ethers';  

import IERC20_raw from './Abis/IERC20';  

import ordersManager_raw from './Abis/Fantom/OrderManager';  
import usersRegistry_raw from './Abis/Fantom/UserRegistry';  

import executionOrdersEngineFantom_raw from './Abis/Fantom/ExecutionOrdersEngineFantom';  
import executionOrdersEngineFromMoonbeam_raw from './Abis/Fantom/ExecutionOrdersEngineFromMoonbeam';  
import executionOrdersEngineFromBinance_raw from './Abis/Fantom/ExecutionOrdersEngineFromBinace';  

import axelarMoonbeamSatelite_raw from './Abis/Moonbeam/AxelarMoobeamSatelite';  
import axelarFantomSatelite_raw from './Abis/Fantom/AxelarFatnomSatelite';  
import axelarBinanceSatelite_raw from './Abis/Binance/AxelarBinaceSatelite';  


// ************************** //
// *** Create a .env file and insert the private key for a Moonbeam EVM account
// *** REACT_APP_PRIVATE_KEY= "YOUR PRIVATE KEY"; 
const PRIVATE_KEY = "2c898ddf4c9d70e1b49495aa583d5b1da62f464f163c9485ea75208b2fc6559c"; //process.env.REACT_APP_PRIVATE_KEY;     
// ************************** //

//FANTOM
const ordersManager_address =  "0x4dF495AcB5911B7042fF60dcdb98CF824C83b345"; 
const usersRegistry_address = "0xbF974CBbd23C6dC01594b26DDCa208C6c9aBA737";
const executionOrdersEngine_Fantom_address = "0x4E1a3C116C0c3cb41EFE1164605021845088dF7B";
const executionOrdersEngineFromMoonbeam_address = "0x04224199314EC7C87E64135b140023EFac976018"; 
const executionOrdersEngineFromBinance_address = "0xeA4100eDA82F1ef314090721ceFDe92DBC98e734";
//FANTOM 
const axelarFantomSatelite_address = "0x823CCF9927D267a0FC4a625b85fC0136C8506Db3";
//MOONBEAM
const axelarMoonbeamSatelite_address = "0x4535498af0373d4F60afde3035FF56c99B6E4D82";
//BINANCE
const axelarBinanceSatelite_address = "0x2b637e9a157d015580CA6cD0223d48cFCcbC3aFb";


const WFTM_address = "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83";    //18 decimals
const BOO_address = "0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE";     //18 decimals
const STG_address = "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590";     //18 decimals
const axlUSDC_Moonbeam_address = "0xCa01a1D0993565291051daFF390892518ACfAD3A";   //6 decimals
const USDC_Moonbeam_address    = "0x931715FEE2d06333043d11F658C8CE934aC61D0c";    //6 decimals
const axlUSDC_Fantom_address = "0x1B6382DBDEa11d97f24495C9A90b7c88469134a4";   //6 decimals
const USDC_Fantom_address    = "0x04068DA6C83AFCFA0e13ba15A6696662335D5B75";   //6 decimals
const axlUSDC_Binance_address = "0x4268B8F0B87b6Eae5d897996E6b845ddbD99Adf3";  //6 decimals
const USDC_Binance_address    = "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d";   //6 decimals

const token_Symbol = {
						"0xCa01a1D0993565291051daFF390892518ACfAD3A" : "axlUSDC_M",
						"0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590" : "STG",
						"0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83" : "WFTM",
						"0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE" : "BOO",
						"0x931715FEE2d06333043d11F658C8CE934aC61D0c" : "USDC_M",
						"0x1B6382DBDEa11d97f24495C9A90b7c88469134a4" : "axlUSDC_F",  //axlUSDC_Fantom_address
						"0x04068DA6C83AFCFA0e13ba15A6696662335D5B75" : "USDC_F",      //USDC_Fantom_address  
						"0x4268B8F0B87b6Eae5d897996E6b845ddbD99Adf3" : "axlUSDC_B",  //axlUSDC_Fantom_address
						"0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d" : "USDC_B"      //USDC_Fantom_address  
					};
const token_Address = {
						"axlUSDC_M"   : "0xCa01a1D0993565291051daFF390892518ACfAD3A",
						"STG"        : "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
						"WFTM"       : "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83",
						"BOO"         : "0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE",
						"USDC_M"      : "0x931715FEE2d06333043d11F658C8CE934aC61D0c",
						"axlUSDC_F"   : "0x1B6382DBDEa11d97f24495C9A90b7c88469134a4",
						"USDC_F"      : "0x04068DA6C83AFCFA0e13ba15A6696662335D5B75",
						"axlUSDC_B"   : "0x4268B8F0B87b6Eae5d897996E6b845ddbD99Adf3",
						"USDC_B"      : "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
					};

const token_decimals = {
						"0xCa01a1D0993565291051daFF390892518ACfAD3A" : 6,
						"0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590" : 18,
						"0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83" : 18,
						"0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE" : 10,
						"0x931715FEE2d06333043d11F658C8CE934aC61D0c" : 6,
						"0x1B6382DBDEa11d97f24495C9A90b7c88469134a4" : 6,  //axlUSDC_Fantom_address
						"0x04068DA6C83AFCFA0e13ba15A6696662335D5B75" : 6,   //USDC_Fantom_address  
						"0x4268B8F0B87b6Eae5d897996E6b845ddbD99Adf3" : 6,  //axlUSDC_Binance_address
						"0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d" : 6   //USDC_Binance_address  
					};				

// Create a new Wallet instance with the private key
const fantom_signer   = new Wallet(PRIVATE_KEY);
const moonbeam_signer = new Wallet(PRIVATE_KEY);
const binance_signer  = new Wallet(PRIVATE_KEY);

//RPC POINTS
const Fantom_RPC = "https://rpc.ankr.com/fantom/";
const Moonbeam_RPC = "https://rpc.api.moonbeam.network";
const Binance_RPC = "https://bsc-dataseed.binance.org/";
 

// Connect the Wallet instance to a provider
const Fantom_provider = new ethers.providers.JsonRpcProvider(Fantom_RPC);
const fantom_wallet = fantom_signer.connect(Fantom_provider);

const Moonbeam_provider = new ethers.providers.JsonRpcProvider(Moonbeam_RPC);
const moonbeam_wallet = moonbeam_signer.connect(Moonbeam_provider);

const Binance_provider = new ethers.providers.JsonRpcProvider(Binance_RPC);
const binance_wallet = binance_signer.connect(Binance_provider);

//Set up contracts
//FANTOM 
const OrdersManager_instance =  new ethers.Contract( ordersManager_address, ordersManager_raw.abi, fantom_wallet);
const UsersRegistry_instance =  new ethers.Contract( usersRegistry_address, usersRegistry_raw.abi, fantom_wallet);
const ExecutionOrdersEngineFantom_instance = new ethers.Contract( executionOrdersEngine_Fantom_address, executionOrdersEngineFantom_raw.abi, fantom_wallet);
const ExecutionOrdersEngineFromMoonbeam_instance = new ethers.Contract(executionOrdersEngineFromMoonbeam_address, executionOrdersEngineFromMoonbeam_raw.abi, fantom_wallet);
const ExecutionOrdersEngineFromBinance_instance = new ethers.Contract(executionOrdersEngineFromBinance_address, executionOrdersEngineFromBinance_raw.abi, fantom_wallet);
//FANTOM 
const AxelarFantomSatelite_instance  = new ethers.Contract(axelarFantomSatelite_address, axelarFantomSatelite_raw.abi, fantom_wallet);
//MOONBEAM 
const AxelarMoonbeamSatelite_instance = new ethers.Contract(axelarMoonbeamSatelite_address, axelarMoonbeamSatelite_raw.abi, moonbeam_wallet);
//BINANCE
const AxelarBinanceSatelite_instance  = new ethers.Contract(axelarBinanceSatelite_address, axelarBinanceSatelite_raw.abi, binance_wallet);


const axelar_fantom_fee = "1";        // 1 FTM 
const axelar_binance_fee = "0.001";   // 0.001 BNB 
const axelar_moonbeam_fee = "2.5";    // 1.5 GLMR


let engineMessage = "Welcome to the  Order Book XChain Orders";


let userChain; //possible values FANTOM MOONBEAM,BINANCE
const setChainOfUser = (_userChain) => {
	userChain = _userChain;       //  MOONBEAM,FANTOM,BINANCE
	console.log(`Selected ===------> userChain: ${userChain}`);
}
const getUserChain = () => {
	return userChain;
}

let wallet, mm_chainId, mm_account;
const setWallet = (_wallet=null, _mm_chainId=null, _mm_account=null) => { 
	if (_wallet) {
		wallet = _wallet;
		mm_chainId = _mm_chainId;
		mm_account = _mm_account;
		console.log(`mm_account: ${mm_account} New wallet : `,wallet,` ***** mm_chainId: ${mm_chainId}`);  
	}
}


const update_SpookySwap_Prices = async () => {
	return new Promise (async (resolve,reject) => {

		const tx_set_SpookySwapPrice =  await OrdersManager_instance.get_SpookySwapPrice();
		try {
			const receipt = await tx_set_SpookySwapPrice.wait();
			if (receipt.status === false) {
				throw new Error("Transaction update_SpookySwap_Prices failed");
			}
			console.log(`********************* OrdersManager_instanceSET SpookySwap Prices End ***********************************`);
			resolve(`********************* OrdersManager_instanceSET SpookySwap Prices End ***********************************`);
		}
		catch (e) {
			console.log(` ********** while  update_SpookySwap_Prices an error occured ********** Error: `,e);
			resolve(` ********** while  update_SpookySwap_Prices an error occured ****`);
  		}

	});

}


const get_SpookySwap_Prices = async () => {
	const boo_USDC   = await OrdersManager_instance.priceUSDC(BOO_address);
	const price_BOO_USDC =(boo_USDC / 1000000).toFixed(5);

	const wftm_USDC = await OrdersManager_instance.priceUSDC(WFTM_address);
	const price_WFTM_USDC =(wftm_USDC / 1000000).toFixed(5);

	const stg_USDC  = await OrdersManager_instance.priceUSDC(STG_address);
	const price_STG_USDC =(stg_USDC / 1000000).toFixed(5);

	// console.log(` PRICES |>     boo_USDC: ${boo_USDC}   wftm_USDC: ${wftm_USDC}   stg_USDC: ${stg_USDC}`);
	return {price_BOO_USDC, price_WFTM_USDC, price_STG_USDC,};
}

const get_Fantom_Balances = async () => {
	// console.log(`********************* Balances Start ***********************************`);
	let account_BOO_Balance="", account_WFTM_Balance="", account_STG_Balance="",account_USDC_Balance="",account_axlSUSDC_Balance="";
	if (userChain==="FANTOM")
	{
		//FOR ERC20 with 18 decimals
		account_BOO_Balance   = await getBalance(BOO_address, mm_account, fantom_wallet, 18);
		account_WFTM_Balance = await getBalance(WFTM_address, mm_account, fantom_wallet, 18);
		account_STG_Balance  = await getBalance(STG_address, mm_account, fantom_wallet, 18);
		//FOR ERC20 with 6 decimals
		account_USDC_Balance      = await getBalance(USDC_Fantom_address, mm_account, fantom_wallet, 6);
		account_axlSUSDC_Balance  = await getBalance(axlUSDC_Fantom_address, mm_account, fantom_wallet, 6);
	}
	else if (userChain==="MOONBEAM")
	{
		account_axlSUSDC_Balance  = await getBalance(axlUSDC_Moonbeam_address, mm_account, moonbeam_wallet, 6);
		// account_USDC_Balance      = await getBalance(USDC_Moonbeam_address, mm_account, moonbeam_wallet, 6);
		account_USDC_Balance = account_axlSUSDC_Balance
		account_BOO_Balance = await getBalanceForMOONBEAMaccount(BOO_address,mm_account,18);
		account_WFTM_Balance = await getBalanceForMOONBEAMaccount(WFTM_address,mm_account,18);
		account_STG_Balance = await getBalanceForMOONBEAMaccount(STG_address,mm_account,18);
	}
	else if (userChain==="BINANCE")
	{
		account_axlSUSDC_Balance  = await getBalance(axlUSDC_Binance_address, mm_account, binance_wallet, 6);
		// account_USDC_Balance      = await getBalance(USDC_Binance_address, mm_account, binance_wallet, 6);
		account_USDC_Balance = account_axlSUSDC_Balance
		account_BOO_Balance = await getBalanceForBINANCEaccount(BOO_address,mm_account,18);
		account_WFTM_Balance = await getBalanceForBINANCEaccount(WFTM_address,mm_account,18);
		account_STG_Balance = await getBalanceForBINANCEaccount(STG_address,mm_account,18);
	}


	return { account_BOO_Balance, account_WFTM_Balance, account_STG_Balance, account_USDC_Balance, account_axlSUSDC_Balance, };
}

const get_OrderBooks = async () => {
    // console.log(`********************* OrdersManager_instance OPEN WORKING ORDERS Start ***********************************`);

	let account_limitOrdersArray=[] ,account_stopOrdersArray=[], account_bracketOrdersArray=[], account_dcaOrdersArray=[];
	let all_limitOrdersArray=[] , all_stopOrdersArray=[], all_bracketOrdersArray=[], all_dcaOrdersArray=[];

	let limitOrdersArray =  await OrdersManager_instance.get_limitOrdersArray();
	for (let i=0; i<limitOrdersArray.length; i++)
	{
		let ord =  await OrdersManager_instance.Orders(limitOrdersArray[i]);
		// console.log(` =-----> mm_account: ${mm_account} limitOrdersArray[${i}]  : ${limitOrdersArray[i]} nonce: ${ord.nonce} owner: ${ord.owner} tokenIn: ${`${ord.tokenIn}`.substring(0,5)}...${`${ord.tokenIn}`.substring(36)} tokenOut: ${`${ord.tokenOut}`.substring(0,5)}...${`${ord.tokenOut}`.substring(36)} limit_price: ${ord.limit_price} stop_price: ${ord.stop_price} size: ${ord.size} block_submitted: ${ord.block_submitted} numOfsplits: ${ord.numOfsplits} order_type: ${ord.order_type} positionAr: ${ord.positionAr} dcaBlockInterval: ${ord.dcaBlockInterval}`);
		if (ord.owner.toLowerCase()===mm_account.toLowerCase()) 
		{
			const _size = Number(ethers.utils.formatUnits( ord.size, token_decimals[ord.tokenIn])).toFixed(3);
			account_limitOrdersArray.push({ nonce: ord.nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price: Number(ord.limit_price)/1000000, stop_price: Number(ord.stop_price)/1000000, size: _size, block_submitted: ord.block_submitted, numOfsplits: "N/A", order_type: ord.order_type, positionAr: ord.positionAr, dcaBlockInterval: "N/A" });
		}
		all_limitOrdersArray.push({ nonce: ord.nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price: ord.limit_price, stop_price: ord.stop_price, size: ord.size, block_submitted: ord.block_submitted, numOfsplits: ord.numOfsplits, order_type: ord.order_type, positionAr: ord.positionAr, dcaBlockInterval: ord.dcaBlockInterval });

	}

	let stopOrdersArray =  await OrdersManager_instance.get_stopOrdersArray();
	for (let i=0; i<stopOrdersArray.length; i++)
	{
		let ord =  await OrdersManager_instance.Orders(stopOrdersArray[i]);
		// console.log(` =-----> stopOrdersArray[${i}]   : ${stopOrdersArray[i]} nonce: ${ord.nonce} owner: ${ord.owner} tokenIn:${`${ord.tokenIn}`.substring(0,5)}...${`${ord.tokenIn}`.substring(36)} tokenOut:${`${ord.tokenOut}`.substring(0,5)}...${`${ord.tokenOut}`.substring(36)} limit_price: ${ord.limit_price} stop_price: ${ord.stop_price} size: ${ord.size} block_submitted: ${ord.block_submitted} numOfsplits: ${ord.numOfsplits} order_type: ${ord.order_type} positionAr: ${ord.positionAr} dcaBlockInterval: ${ord.dcaBlockInterval}`);

		if (ord.owner.toLowerCase()===mm_account.toLowerCase()) 
		{
			const _size = Number(ethers.utils.formatUnits( ord.size, token_decimals[ord.tokenIn])).toFixed(3);
			account_stopOrdersArray.push({ nonce: ord.nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price: Number(ord.limit_price)/1000000, stop_price: Number(ord.stop_price)/1000000, size: _size, block_submitted: ord.block_submitted, numOfsplits: "N/A", order_type: ord.order_type, positionAr: ord.positionAr, dcaBlockInterval: "N/A" });
		}
		all_stopOrdersArray.push({ nonce: ord.nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price: ord.limit_price, stop_price: ord.stop_price, size: ord.size, block_submitted: ord.block_submitted, numOfsplits: ord.numOfsplits, order_type: ord.order_type, positionAr: ord.positionAr, dcaBlockInterval: ord.dcaBlockInterval });
		
	}

	let bracketOrdersArray =  await OrdersManager_instance.get_bracketOrdersArray();
	for (let i=0; i<bracketOrdersArray.length; i++)
	{
		let ord =  await OrdersManager_instance.Orders(bracketOrdersArray[i]);
		// console.log(` =-----> bracketOrdersArray[${i}]: ${bracketOrdersArray[i]} nonce: ${ord.nonce} owner: ${ord.owner} tokenIn: ${`${ord.tokenIn}`.substring(0,5)}...${`${ord.tokenIn}`.substring(36)} tokenOut: ${`${ord.tokenOut}`.substring(0,5)}...${`${ord.tokenOut}`.substring(36)} limit_price: ${ord.limit_price} stop_price: ${ord.stop_price} size: ${ord.size} block_submitted: ${ord.block_submitted} numOfsplits: ${ord.numOfsplits} order_type: ${ord.order_type} positionAr: ${ord.positionAr} dcaBlockInterval: ${ord.dcaBlockInterval}`);

		if (ord.owner.toLowerCase()===mm_account.toLowerCase()) 
		{
			const _size = Number(ethers.utils.formatUnits( ord.size, token_decimals[ord.tokenIn])).toFixed(3);
			account_bracketOrdersArray.push({ nonce: ord.nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price:  Number(ord.limit_price)/1000000, stop_price:  Number(ord.stop_price)/1000000, size: _size, block_submitted: ord.block_submitted, numOfsplits: "N/A", order_type: ord.order_type, positionAr: ord.positionAr, dcaBlockInterval: "N/A" });
		}
		all_bracketOrdersArray.push({ nonce: ord.nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price: ord.limit_price, stop_price: ord.stop_price, size: ord.size, block_submitted: ord.block_submitted, numOfsplits: ord.numOfsplits, order_type: ord.order_type, positionAr: ord.positionAr, dcaBlockInterval: ord.dcaBlockInterval });
		
	}

	let dcaOrdersArray =  await OrdersManager_instance.get_dcaOrdersArray();
	for (let i=0; i<dcaOrdersArray.length; i++)
	{
		let ord =  await OrdersManager_instance.Orders(dcaOrdersArray[i]);
		// console.log(` =-----> dcaOrdersArray[${i}]    : ${dcaOrdersArray[i]} nonce: ${ord.nonce} owner: ${ord.owner} tokenIn: ${`${ord.tokenIn}`.substring(0,5)}...${`${ord.tokenIn}`.substring(36)} tokenOut: ${`${ord.tokenOut}`.substring(0,5)}...${`${ord.tokenOut}`.substring(36)} limit_price: ${ord.limit_price} stop_price: ${ord.stop_price} size: ${ord.size} block_submitted: ${ord.block_submitted} numOfsplits: ${ord.numOfsplits} order_type: ${ord.order_type} positionAr: ${ord.positionAr} dcaBlockInterval: ${ord.dcaBlockInterval}`);

		if (ord.owner.toLowerCase()===mm_account.toLowerCase()) 
		{
			const _size = Number(ethers.utils.formatUnits( ord.size, token_decimals[ord.tokenIn])).toFixed(3);
			account_dcaOrdersArray.push({ nonce: ord.nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price: "N/A", stop_price: "N/A", size: _size, block_submitted: ord.block_submitted, numOfsplits: ord.numOfsplits, order_type: ord.order_type, positionAr: ord.positionAr, dcaBlockInterval: ord.dcaBlockInterval });
		}
		all_dcaOrdersArray.push({ nonce: ord.nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price: ord.limit_price, stop_price: ord.stop_price, size: ord.size, block_submitted: ord.block_submitted, numOfsplits: ord.numOfsplits, order_type: ord.order_type, positionAr: ord.positionAr, dcaBlockInterval: ord.dcaBlockInterval });

	}
    // console.log(`********************* OrdersManager_instance OPEN WORKING ORDERS End ***********************************`);
	return { account_limitOrdersArray, account_stopOrdersArray, account_bracketOrdersArray, account_dcaOrdersArray, all_limitOrdersArray, all_stopOrdersArray, all_bracketOrdersArray, all_dcaOrdersArray };
}


const get_ExecutionsPendingOrderBook_Fantom = async () => {
    // console.log(`********************* ExecutionOrdersEngineFantom_instance Start ***********************************`);
	let all_QueuedForExecutionOrder_Fantom=[];
	let pendingOrders_FANTOM =  await ExecutionOrdersEngineFantom_instance.get_pendingOrders_FANTOM();
	for (let i=0; i<pendingOrders_FANTOM.length; i++)
	{
		let ord =  await ExecutionOrdersEngineFantom_instance.Orders(pendingOrders_FANTOM[i]);
		// console.log(` =-----> pendingOrders_FANTOM[${i}]: ${pendingOrders_FANTOM[i]}  engine_nonce: ${ord.engine_nonce} origin_nonce: ${ord.origin_nonce} owner: ${ord.owner} tokenIn:${`${ord.tokenIn}`.substring(0,5)}...${`${ord.tokenIn}`.substring(36)} tokenOut:${`${ord.tokenOut}`.substring(0,5)}...${`${ord.tokenOut}`.substring(36)} limit_price: ${ord.limit_price} stop_price: ${ord.stop_price} size: ${ord.size} block_submitted: ${ord.block_submitted} order_type: ${ord.order_type} positionAr: ${ord.positionAr}`);
		all_QueuedForExecutionOrder_Fantom.push({ engine_nonce: ord.engine_nonce,  origin_nonce: ord.origin_nonce, owner: ord.owner, tokenIn: token_Symbol[ord.tokenIn], tokenOut: token_Symbol[ord.tokenOut], limit_price: ord.limit_price, stop_price: ord.stop_price, size: ord.size, block_submitted: ord.block_submitted, order_type: ord.order_type, positionAr: ord.positionAr });
	}
	// console.log(`********************* ExecutionOrdersEngineFantom_instance End ***********************************`);
	return {all_QueuedForExecutionOrder_Fantom,};
}

// userChain can be "FANTOM","MOONBEAM","BINANCE"
const registerUser_Fantom = async () => {

	let isUserRegistered =  await UsersRegistry_instance.isUserRegistered(mm_account);
	console.log(`registerUser_Fantom is run from userChain: ${userChain} for account: ${mm_account} isUserRegistered: ${isUserRegistered}`);

    return new Promise (async (resolve,reject) => {
		if (userChain==="FANTOM")
		{
			if (!isUserRegistered)
			{
				const user_UsersRegistry_instance =  new ethers.Contract( usersRegistry_address, usersRegistry_raw.abi, wallet);
				
				const tx_register_user =  await user_UsersRegistry_instance.registerUser( mm_account, mm_account, "FANTOM", mm_account, "");
				tx_register_user.wait().then( async reslveMsg => {
					console.log(`tx_register_user is mined resolveMsg : `,reslveMsg);
		
					const userStruct =  await UsersRegistry_instance.users(mm_account);
					isUserRegistered =  await UsersRegistry_instance.isUserRegistered(mm_account);
					console.log(`isUserRegistered: ${isUserRegistered} userStruct: `,userStruct);
					resolve(reslveMsg);
				});
			}
			else {
				console.log(`User ${mm_account} is already registered`);
				resolve(null);
			}

		}
		else 
		{
			console.log(`User ${mm_account} will be registered automatically via AxelarFantombeamSatelite sc`);
			resolve(`User ${mm_account} will be registered automatically via AxelarFantombeamSatelite sc`);
		}

	})

};



const submitOrder_Fantom = async (tokenIn="USDC_F", tokenOut="BOO", _limitPrice="20", _stopPrice="0", _size="23", num_Ofsplits="0", orderType="1", dcaBlockInterval="0" ) => {
	console.log(`submitOrder_Fantom is run`);
	let tokenInAddress  = token_Address[tokenIn];
	let tokenOutAddress = token_Address[tokenOut];

	const limitPrice = ethers.utils.parseUnits( _limitPrice, 6 );
	const stopPrice = ethers.utils.parseUnits( _stopPrice, 6 );

	 
	//REGISTER USER
	const registerMessage = await registerUser_Fantom();
	console.log(`submitOrder_Fantom USER IS NOW REGISTERED registerMessage: `,registerMessage);
	
	//FORMAT SIZE
	const sizeWEI =  ethers.utils.parseUnits( _size, token_decimals[tokenInAddress]);

	let approve_sizeWEI;
	if (orderType==="4") //DCA
	{
		approve_sizeWEI =  ethers.utils.parseUnits( `${Number(_size) * Number(num_Ofsplits)}` , token_decimals[tokenInAddress]);
	}
	else approve_sizeWEI = sizeWEI;
	

    return new Promise (async (resolve,reject) => {

		if (userChain==="FANTOM")
		{

			const erc20 =  new ethers.Contract( tokenInAddress, IERC20_raw.abi, wallet);
			const allowance = await erc20.allowance(mm_account, executionOrdersEngine_Fantom_address );
			const futureAllowance = allowance.add( approve_sizeWEI );
			const balanceWEI = await erc20.balanceOf(mm_account);
			console.log(`submitOrder_Fantom for tokenIn allowance was: ${allowance} and it will now become ${typeof futureAllowance} ${typeof balanceWEI} futureAllowance: ${futureAllowance} balanceWEI: ${balanceWEI}`);

			if ( futureAllowance.gt(balanceWEI) )
			{
				console.log(`NOT ENOUGH BALANCE`);
				console.log(`THE ORDER WILL NOT BE SUBMITTED`);
				console.log(` `);
				reject("Not enough BalaNce. The order will not be submitted !!! ");
			}

			
			const tx2 = await erc20.approve(executionOrdersEngine_Fantom_address, futureAllowance );
			tx2.wait().then( async reslveMsg => {
				console.log(`tx2 fro approval is mined resolveMsg : `,reslveMsg);

				const allowance = await erc20.allowance(mm_account, executionOrdersEngine_Fantom_address );
				console.log(`submitOrder_Fantom for tokenIn NEW allowance: ${allowance}`);

				console.log(`***** Submiting Limit Order ****`);
				const user_OrdersManager_instance =  new ethers.Contract( ordersManager_address, ordersManager_raw.abi, wallet);

				console.log(`***** Submiting Limit Order ****`);
				console.log(` `);
				console.log(`***** READY TO SUBMIT tokenInAddress: ${tokenInAddress} tokenOutAddress: ${tokenOutAddress} ****`);
				console.log(`***** READY TO SUBMIT limitPrice: ${limitPrice} stopPrice: ${stopPrice} sizeWEI: ${sizeWEI} num_Ofsplits: ${num_Ofsplits} orderType: ${orderType} dcaBlockInterval: ${dcaBlockInterval} ****`);
				console.log(` `);
				console.log(`***** Submiting Limit Order ****`);

				// resolve("ALL G O O D");

				const gasEstimate = await user_OrdersManager_instance.estimateGas.submit_Order( mm_account, tokenInAddress, tokenOutAddress, limitPrice, stopPrice, sizeWEI, num_Ofsplits, orderType, dcaBlockInterval ); 
				const gasPremium = gasEstimate.mul(130).div(100);
				console.log(`tx_submit_order => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

				try {
					const tx_submit_order =  await user_OrdersManager_instance.submit_Order( mm_account, tokenInAddress, tokenOutAddress, limitPrice, stopPrice, sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { gasPrice: 160000000000, gasLimit: gasPremium }  );
					const receipt = await tx_submit_order.wait(); 
					if (receipt.status === false) {
					  throw new Error("Transaction tx_submit_order failed");
					}
					// console.log(` ===--------> tx_submit_order is mined resolveMsg : `,reslveMsg);
					resolve(`*** OrdersManager_instance tx_submit_order is mined ***`);
				}
				catch (e) {
					console.log(` * while  OrdersManager_instance tx_submit_order an error occured * Error: `,e);
					resolve(` * while  OrdersManager_instance tx_submit_order an error occured  * `);
				}
			
			});


		}
		else if (userChain==="MOONBEAM")
		{
			const user_AxelarMoonbeamSatelite_instance =  new ethers.Contract( axelarMoonbeamSatelite_address, axelarMoonbeamSatelite_raw.abi, wallet);
			
			if (tokenIn==="USDC_F")
			{
				console.log(` ****> submitOrder_Moonbeam -> userChain: ${userChain} tokenIn: ${tokenIn} tokenOut: ${tokenOut} tokenInAddress: ${tokenInAddress}`);
				const axlUSDC =  new ethers.Contract( axlUSDC_Moonbeam_address, IERC20_raw.abi, wallet);
				const allowance = await axlUSDC.allowance(mm_account, axelarMoonbeamSatelite_address );
				const futureAllowance = allowance.add( approve_sizeWEI );
				const balanceWEI = await axlUSDC.balanceOf(mm_account);
				console.log(`****> submitOrder_Moonbeam -> userChain: ${userChain}  for tokenIn allowance was: ${allowance} and it will now become futureAllowance: ${futureAllowance} balanceWEI: ${balanceWEI}`);
	
				if ( futureAllowance.gt(balanceWEI) )
				{
					console.log(`NOT ENOUGH BALANCE`);
					console.log(`THE ORDER WILL NOT BE SUBMITTED`);
					console.log(` `);
					reject("Not enough BalaNce. The order will not be submitted !!! ");
				}

				const tx2 = await axlUSDC.approve(axelarMoonbeamSatelite_address, futureAllowance );
				tx2.wait().then( async reslveMsg => {
					console.log(`****> submitOrder_Moonbeam -> userChain: ${userChain} tx2 from approval is mined resolveMsg : `,reslveMsg);
	
					const allowance = await axlUSDC.allowance(mm_account, axlUSDC_Moonbeam_address );
					console.log(`submitOrder_Moonbeam for tokenIn NEW allowance: ${allowance}`);
					console.log(`***** Submiting Order ****`);
					console.log(`***** READY TO SUBMIT tokenInAddress: ${tokenInAddress} tokenOutAddress: ${tokenOutAddress} ****`);
					console.log(`***** READY TO SUBMIT limitPrice: ${limitPrice} stopPrice: ${stopPrice} sizeWEI: ${sizeWEI} num_Ofsplits: ${num_Ofsplits} orderType: ${orderType} dcaBlockInterval: ${dcaBlockInterval} ****`);
					console.log(`***** Submiting Order ****`);

					const gasEstimate = await user_AxelarMoonbeamSatelite_instance.estimateGas.submitOrderTo_Fantom( tokenInAddress, tokenOutAddress, limitPrice, stopPrice, sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { value: ethers.utils.parseEther(axelar_moonbeam_fee) } ); 
					const gasPremium = gasEstimate.mul(130).div(100);
					console.log(`tx_submit_order => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

					// resolve("ALL G O O D 1");
	
					try {
						const tx_submit_order =  await user_AxelarMoonbeamSatelite_instance.submitOrderTo_Fantom( tokenInAddress, tokenOutAddress, limitPrice, stopPrice, sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { value: ethers.utils.parseEther(axelar_moonbeam_fee), gasLimit: gasPremium }  );
						const receipt = await tx_submit_order.wait(); 
						if (receipt.status === false) {
						  throw new Error("Transaction tx_submit_order failed");
						}
						resolve(`*** user_AxelarMoonbeamSatelite_instance tx_submit_order is mined ***`);
					}
					catch (e) {
						console.log(` * while  user_AxelarMoonbeamSatelite_instance tx_submit_order an error occured * Error: `,e);
						resolve(` * while  user_AxelarMoonbeamSatelite_instance tx_submit_order an error occured  * `);
					}
				
				});

			}
			else if (tokenOut==="USDC_F" && (tokenIn==="BOO" || tokenIn==="WFTM" || tokenIn==="STG"))
			{
				let _sizeWEI = sizeWEI;
				let account_tokenIn_balance;
				if (tokenIn==="BOO")
				{
					account_tokenIn_balance = await ExecutionOrdersEngineFromMoonbeam_instance.userBalance(mm_account,BOO_address);
				}
                else if (tokenIn==="WFTM")
				{
					account_tokenIn_balance = await ExecutionOrdersEngineFromMoonbeam_instance.userBalance(mm_account,WFTM_address);
				}
				else if (tokenIn==="STG")
				{
					account_tokenIn_balance = await ExecutionOrdersEngineFromMoonbeam_instance.userBalance(mm_account,STG_address);
				}
				
				console.log(`***** account_tokenIn_balance: ${account_tokenIn_balance} ****`);

				if (sizeWEI.gt(account_tokenIn_balance)) _sizeWEI = account_tokenIn_balance;

				if (_sizeWEI.isZero())
				{
					console.log(`***** Submiting Order SIZE CANNOT BE ZERO _sizeWEI: ${_sizeWEI} ****`);
					resolve(`***** Submiting Order SIZE CANNOT BE ZERO _sizeWEI: ${_sizeWEI} ****`);
					return;
				}


				console.log(`***** Submiting Order account_tokenIn_balance: ${account_tokenIn_balance} ****`);
				console.log(`***** READY TO SUBMIT tokenInAddress: ${tokenInAddress} tokenOutAddress: ${tokenOutAddress} ****`);
				console.log(`***** READY TO SUBMIT limitPrice: ${limitPrice} stopPrice: ${stopPrice} _sizeWEI: ${_sizeWEI} sizeWEI: ${sizeWEI} num_Ofsplits: ${num_Ofsplits} orderType: ${orderType} dcaBlockInterval: ${dcaBlockInterval} ****`);
				console.log(`***** Submiting Order ****`);


				const gasEstimate = await user_AxelarMoonbeamSatelite_instance.estimateGas.submitOrderTo_Fantom( tokenInAddress, tokenOutAddress, limitPrice, stopPrice, _sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { value: ethers.utils.parseEther(axelar_moonbeam_fee) } ); 
				const gasPremium = gasEstimate.mul(130).div(100);
				console.log(`tx_submit_order => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);


				// resolve("ALL G O O D  2");
	
				try {
					const tx_submit_order =  await user_AxelarMoonbeamSatelite_instance.submitOrderTo_Fantom( tokenInAddress, tokenOutAddress, limitPrice, stopPrice, _sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { value: ethers.utils.parseEther(axelar_moonbeam_fee), gasLimit: gasPremium }  );
					const receipt = await tx_submit_order.wait(); 
					if (receipt.status === false) {
					  throw new Error("Transaction tx_submit_order failed");
					}
					resolve(`*** user_AxelarMoonbeamSatelite_instance tx_submit_order is mined ***`);
				}
				catch (e) {
					console.log(` * while  user_AxelarMoonbeamSatelite_instance tx_submit_order an error occured * Error: `,e);
					resolve(` * while  user_AxelarMoonbeamSatelite_instance tx_submit_order an error occured  * `);
				}

			}

		}



		else if (userChain==="BINANCE")
		{
			const user_AxelarBinanceSatelite_instance =  new ethers.Contract( axelarBinanceSatelite_address, axelarBinanceSatelite_raw.abi, wallet);
			
			if (tokenIn==="USDC_F")
			{
				console.log(` ****> submitOrder_Fantom -> userChain: ${userChain} tokenIn: ${tokenIn} tokenOut: ${tokenOut} tokenInAddress: ${tokenInAddress}`);
				const axlUSDC =  new ethers.Contract( axlUSDC_Binance_address, IERC20_raw.abi, wallet);
				const allowance = await axlUSDC.allowance(mm_account, axelarBinanceSatelite_address );
				const futureAllowance = allowance.add( approve_sizeWEI );
				const balanceWEI = await axlUSDC.balanceOf(mm_account);
				console.log(`****> submitOrder_Fantom -> userChain: ${userChain}  for tokenIn allowance was: ${allowance} and it will now become futureAllowance: ${futureAllowance} balanceWEI: ${balanceWEI}`);
	
				if ( futureAllowance.gt(balanceWEI) )
				{
					console.log(`NOT ENOUGH BALANCE`);
					console.log(`THE ORDER WILL NOT BE SUBMITTED`);
					console.log(` `);
					reject("Not enough BalaNce. The order will not be submitted !!! ");
				}

				const tx2 = await axlUSDC.approve(axelarBinanceSatelite_address, futureAllowance );
				tx2.wait().then( async reslveMsg => {
					console.log(`****> submitOrder_Fantom -> userChain: ${userChain} tx2 from approval is mined resolveMsg : `,reslveMsg);
	
					const allowance = await axlUSDC.allowance(mm_account, axelarBinanceSatelite_address );
					console.log(`submitOrder_Fantom for tokenIn NEW allowance: ${allowance}`);
					console.log(`***** Submiting Order ****`);
					console.log(`***** READY TO SUBMIT tokenInAddress: ${tokenInAddress} tokenOutAddress: ${tokenOutAddress} ****`);
					console.log(`***** READY TO SUBMIT limitPrice: ${limitPrice} stopPrice: ${stopPrice} sizeWEI: ${sizeWEI} num_Ofsplits: ${num_Ofsplits} orderType: ${orderType} dcaBlockInterval: ${dcaBlockInterval} ****`);
					console.log(`***** Submiting Order ****`);

					const gasEstimate = await user_AxelarBinanceSatelite_instance.estimateGas.submitOrderTo_Fantom( tokenInAddress, tokenOutAddress, limitPrice, stopPrice, sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { value: ethers.utils.parseEther(axelar_binance_fee) } ); 
					const gasPremium = gasEstimate.mul(130).div(100);
					console.log(`tx_submit_order => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

					// resolve("ALL G O O D 1");
	
					try {
						const tx_submit_order =  await user_AxelarBinanceSatelite_instance.submitOrderTo_Fantom( tokenInAddress, tokenOutAddress, limitPrice, stopPrice, sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { value: ethers.utils.parseEther(axelar_binance_fee), gasLimit: gasPremium }  );
						const receipt = await tx_submit_order.wait(); 
						if (receipt.status === false) {
						  throw new Error("Transaction tx_submit_order failed");
						}
						resolve(`*** user_AxelarBinanceSatelite_instance tx_submit_order is mined ***`);
					}
					catch (e) {
						console.log(` * while  user_AxelarBinanceSatelite_instance tx_submit_order an error occured * Error: `,e);
						resolve(` * while  user_AxelarBinanceSatelite_instance tx_submit_order an error occured  * `);
					}
				
				});

			}
			else if (tokenOut==="USDC_M" && (tokenIn==="BOO" || tokenIn==="WFTM" || tokenIn==="STG"))
			{
				let _sizeWEI = sizeWEI;
				let account_tokenIn_balance;
				if (tokenIn==="BOO")
				{
					account_tokenIn_balance = await ExecutionOrdersEngineFromBinance_instance.userBalance(mm_account,BOO_address);
				}
                else if (tokenIn==="WFTM")
				{
					account_tokenIn_balance = await ExecutionOrdersEngineFromBinance_instance.userBalance(mm_account,WFTM_address);
				}
				else if (tokenIn==="STG")
				{
					account_tokenIn_balance = await ExecutionOrdersEngineFromBinance_instance.userBalance(mm_account,STG_address);
				}
				
				console.log(`***** account_tokenIn_balance: ${account_tokenIn_balance} ****`);

				if (sizeWEI.gt(account_tokenIn_balance)) _sizeWEI = account_tokenIn_balance;

				if (_sizeWEI.isZero())
				{
					console.log(`***** Submiting Order SIZE CANNOT BE ZERO _sizeWEI: ${_sizeWEI} ****`);
					resolve(`***** Submiting Order SIZE CANNOT BE ZERO _sizeWEI: ${_sizeWEI} ****`);
					return;
				}


				console.log(`***** Submiting Order account_tokenIn_balance: ${account_tokenIn_balance} ****`);
				console.log(`***** READY TO SUBMIT tokenInAddress: ${tokenInAddress} tokenOutAddress: ${tokenOutAddress} ****`);
				console.log(`***** READY TO SUBMIT limitPrice: ${limitPrice} stopPrice: ${stopPrice} _sizeWEI: ${_sizeWEI} sizeWEI: ${sizeWEI} num_Ofsplits: ${num_Ofsplits} orderType: ${orderType} dcaBlockInterval: ${dcaBlockInterval} ****`);
				console.log(`***** Submiting Order ****`);


				const gasEstimate = await user_AxelarBinanceSatelite_instance.estimateGas.submitOrderTo_Fantom( tokenInAddress, tokenOutAddress, limitPrice, stopPrice, _sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { value: ethers.utils.parseEther(axelar_binance_fee) } ); 
				const gasPremium = gasEstimate.mul(130).div(100);
				console.log(`tx_submit_order => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);


				// resolve("ALL G O O D  2");
	
				try {
					const tx_submit_order =  await user_AxelarBinanceSatelite_instance.submitOrderTo_Fantom( tokenInAddress, tokenOutAddress, limitPrice, stopPrice, _sizeWEI, num_Ofsplits, orderType, dcaBlockInterval, { value: ethers.utils.parseEther(axelar_binance_fee), gasLimit: gasPremium }  );
					const receipt = await tx_submit_order.wait(); 
					if (receipt.status === false) {
					  throw new Error("Transaction tx_submit_order failed");
					}
					resolve(`*** user_AxelarBinanceSatelite_instance tx_submit_order is mined ***`);
				}
				catch (e) {
					console.log(` * while  user_AxelarBinanceSatelite_instance tx_submit_order an error occured * Error: `,e);
					resolve(` * while  user_AxelarBinanceSatelite_instance tx_submit_order an error occured  * `);
				}

			}

		}

	})

};


 
const deleteOrder_Fantom = async (orderNonce,_size,tokenIn) => {
	console.log(`deleteOrder_Fantom is run for orderNonce: ${orderNonce}`);
	console.log(`********************* OrdersManager_instance DELETE ORDER Start orderNonce: ${orderNonce} orderSize: ${_size} tokenIn: ${tokenIn} ***********************************`);
    
	return new Promise (async (resolve,reject) => {

		const tokenInAddress  = token_Address[tokenIn];
		const sizeWEI =  ethers.utils.parseUnits( _size, token_decimals[tokenInAddress]);

		if (userChain==="FANTOM")
		{
			const erc20 =  new ethers.Contract( tokenInAddress, IERC20_raw.abi, wallet);
			const allowance = await erc20.allowance(mm_account, ordersManager_address );

			if ( allowance.gt(sizeWEI) )
			{
				const futureAllowance = allowance.sub(sizeWEI);

				const tx2 = await erc20.approve(ordersManager_address, futureAllowance );
				tx2.wait().then( async reslveMsg => {
					console.log(`tx2 fro approval is mined resolveMsg : `,reslveMsg);

					const allowance = await erc20.allowance(mm_account, ordersManager_address );
					console.log(`submitOrder_Fantom for tokenIn NEW allowance: ${allowance}`);
				});

			}

			const user_OrdersManager_instance =  new ethers.Contract( ordersManager_address, ordersManager_raw.abi, wallet);

			const gasEstimate = await user_OrdersManager_instance.estimateGas.delete_Order( orderNonce ); //ethers.BigNumber.from( "300000" ); 
			const gasPremium = gasEstimate.mul(130).div(100);
			console.log(`deleteOrder_Fantom => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

			try {
				const tx_delete_order =  await user_OrdersManager_instance.delete_Order( orderNonce, { gasLimit: gasPremium } );
				const receipt = await tx_delete_order.wait(); 
				if (receipt.status === false) {
				throw new Error("Transaction tx_delete_order failed");
				}
				console.log(`*** OrdersManager_instance DELETE ORDER End is mined orderNonce: ${orderNonce} *** `);
				resolve(`*** OrdersManager_instance DELETE ORDER End is mined orderNonce: ${orderNonce} ***`);
			}
			catch (e) {
				console.log(` * while  OrdersManager_instance DELETE ORDER orderNonce: ${orderNonce} an error occured * Error: `,e);
				resolve(` * while  OrdersManager_instance DELETE ORDER orderNonce: ${orderNonce} an error occured * `);
			}

		}
		else if (userChain==="MOONBEAM")
		{

			const user_AxelarMoonbeamSatelite_instance =  new ethers.Contract( axelarMoonbeamSatelite_address, axelarMoonbeamSatelite_raw.abi, wallet);
			
			if (tokenIn==="USDC_F")
			{
				console.log(` ****> deleteOrder_Fantom tokenIn: -> userChain: ${userChain} tokenIn: ${tokenIn}`);

				const axlUSDC =  new ethers.Contract( axlUSDC_Moonbeam_address, IERC20_raw.abi, wallet);
				const allowance = await axlUSDC.allowance(mm_account, axelarMoonbeamSatelite_address );
				console.log(`****> deleteOrder_Fantom -> userChain: ${userChain} allowance: ${allowance}`);

				if ( allowance.gt(sizeWEI) )
				{
					const futureAllowance = allowance.sub(sizeWEI);
	
					const tx2 = await axlUSDC.approve(axelarMoonbeamSatelite_address, futureAllowance );
					tx2.wait().then( async reslveMsg => {
						console.log(`****> deleteOrder_Fantom -> userChain: ${userChain} tx2 from approval is mined resolveMsg : `,reslveMsg);

						const allowance = await axlUSDC.allowance(mm_account, axelarMoonbeamSatelite_address );
						console.log(`****> deleteOrder_Fantom -> userChain: ${userChain} NEW allowance: ${allowance}`);
					});
				}


				const gasEstimate = await user_AxelarMoonbeamSatelite_instance.estimateGas.cancelOrderTo_Fantom( orderNonce, { value: ethers.utils.parseEther(axelar_moonbeam_fee) } ); 
				const gasPremium = gasEstimate.mul(130).div(100);
				console.log(`***> deleteOrder_Fantom -> userChain: ${userChain} => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

				// resolve("ALL G O O D 3");

				try {
					const tx_delete_order =  await user_AxelarMoonbeamSatelite_instance.cancelOrderTo_Fantom( orderNonce, { value: ethers.utils.parseEther(axelar_moonbeam_fee) } );
					const receipt = await tx_delete_order.wait(); 
					if (receipt.status === false) {
					  throw new Error("Transaction tx_delete_order failed");
					}
					resolve(`*** user_AxelarMoonbeamSatelite_instance tx_delete_order is mined ***`);
				}
				catch (e) {
					console.log(` * while  user_AxelarMoonbeamSatelite_instance tx_delete_order an error occured * Error: `,e);
					resolve(` * while  user_AxelarMoonbeamSatelite_instance tx_delete_order an error occured  * `);
				}

			}
			else
			{
				console.log(` ****> deleteOrder_Fantom tokenIn: -> userChain: ${userChain} tokenIn: ${tokenIn}`);

				const gasEstimate = await user_AxelarMoonbeamSatelite_instance.estimateGas.cancelOrderTo_Fantom( orderNonce, { value: ethers.utils.parseEther(axelar_moonbeam_fee) } ); 
				const gasPremium = gasEstimate.mul(130).div(100);
				console.log(`***> deleteOrder_Fantom -> userChain: ${userChain} => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

				// resolve("ALL G O O D 4");

				try {
					const tx_delete_order =  await user_AxelarMoonbeamSatelite_instance.cancelOrderTo_Fantom( orderNonce, { value: ethers.utils.parseEther(axelar_moonbeam_fee) } );
					const receipt = await tx_delete_order.wait(); 
					if (receipt.status === false) {
					  throw new Error("Transaction tx_delete_order failed");
					}
					resolve(`*** user_AxelarMoonbeamSatelite_instance tx_delete_order is mined ***`);
				}
				catch (e) {
					console.log(` * while  user_AxelarMoonbeamSatelite_instance tx_delete_order an error occured * Error: `,e);
					resolve(` * while  user_AxelarMoonbeamSatelite_instance tx_delete_order an error occured  * `);
				}
			}

		}





		else if (userChain==="BINANCE")
		{

			const user_AxelarBinanceSatelite_instance =  new ethers.Contract( axelarBinanceSatelite_address, axelarBinanceSatelite_raw.abi, wallet);
			
			if (tokenIn==="USDC_M")
			{
				console.log(` ****> deleteOrder_Fantom tokenIn: -> userChain: ${userChain} tokenIn: ${tokenIn}`);

				const axlUSDC =  new ethers.Contract( axlUSDC_Binance_address, IERC20_raw.abi, wallet);
				const allowance = await axlUSDC.allowance(mm_account, axelarBinanceSatelite_address );
				console.log(`****> deleteOrder_Fantom -> userChain: ${userChain} allowance: ${allowance}`);

				if ( allowance.gt(sizeWEI) )
				{
					const futureAllowance = allowance.sub(sizeWEI);
	
					const tx2 = await axlUSDC.approve(axelarBinanceSatelite_address, futureAllowance );
					tx2.wait().then( async reslveMsg => {
						console.log(`****> deleteOrder_Fantom -> userChain: ${userChain} tx2 from approval is mined resolveMsg : `,reslveMsg);

						const allowance = await axlUSDC.allowance(mm_account, axelarBinanceSatelite_address );
						console.log(`****> deleteOrder_Fantom -> userChain: ${userChain} NEW allowance: ${allowance}`);
					});
				}


				const gasEstimate = await user_AxelarBinanceSatelite_instance.estimateGas.cancelOrderTo_Fantom( orderNonce, { value: ethers.utils.parseEther(axelar_binance_fee) } ); 
				const gasPremium = gasEstimate.mul(130).div(100);
				console.log(`***> deleteOrder_Fantom -> userChain: ${userChain} => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

				// resolve("ALL G O O D 3");

				try {
					const tx_delete_order =  await user_AxelarBinanceSatelite_instance.cancelOrderTo_Fantom( orderNonce, { value: ethers.utils.parseEther(axelar_binance_fee) } );
					const receipt = await tx_delete_order.wait(); 
					if (receipt.status === false) {
					  throw new Error("Transaction tx_delete_order failed");
					}
					resolve(`*** user_AxelarBinanceSatelite_instance tx_delete_order is mined ***`);
				}
				catch (e) {
					console.log(` * while  user_AxelarBinanceSatelite_instance tx_delete_order an error occured * Error: `,e);
					resolve(` * while  user_AxelarBinanceSatelite_instance tx_delete_order an error occured  * `);
				}

			}
			else
			{
				console.log(` ****> deleteOrder_Fantom tokenIn: -> userChain: ${userChain} tokenIn: ${tokenIn}`);

				const gasEstimate = await user_AxelarBinanceSatelite_instance.estimateGas.cancelOrderTo_Fantom( orderNonce, { value: ethers.utils.parseEther(axelar_binance_fee) } ); 
				const gasPremium = gasEstimate.mul(130).div(100);
				console.log(`***> deleteOrder_Fantom -> userChain: ${userChain} => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

				// resolve("ALL G O O D 4");

				try {
					const tx_delete_order =  await user_AxelarBinanceSatelite_instance.cancelOrderTo_Fantom( orderNonce, { value: ethers.utils.parseEther(axelar_binance_fee) } );
					const receipt = await tx_delete_order.wait(); 
					if (receipt.status === false) {
					  throw new Error("Transaction tx_delete_order failed");
					}
					resolve(`*** user_AxelarBinanceSatelite_instance tx_delete_order is mined ***`);
				}
				catch (e) {
					console.log(` * while  user_AxelarBinanceSatelite_instance tx_delete_order an error occured * Error: `,e);
					resolve(` * while  user_AxelarBinanceSatelite_instance tx_delete_order an error occured  * `);
				}
			}

		}

	});

};


const checkLimitOrders = async () => {
	return new Promise (async (resolve,reject) => {

		console.log(`*********************  checkLimitOrders Start ***********************************`);
		const gasEstimate = await OrdersManager_instance.estimateGas.checkLimitOrders();
		const gasPremium = gasEstimate.mul(130).div(100);
		console.log(`checkLimitOrders => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

		try {
			const tx_checkLimitOrders =  await OrdersManager_instance.checkLimitOrders({ gasLimit: gasPremium });
			const receipt = await tx_checkLimitOrders.wait(); 
			if (receipt.status === false) {
			throw new Error("Transaction checkLimitOrders failed");
			}
			console.log(`***  checkLimitOrders End ***`);
			resolve(`***  checkLimitOrders End ***`);
		}
		catch (e) {
			console.log(` *** while  checkLimitOrders an error occured *** Error: `,e);
			resolve(` *** while  checkLimitOrders an error occured *** `);
		}
	});

}
const checkStopOrders = async () => {
	return new Promise (async (resolve,reject) => {

		console.log(`*********************  checkStopOrders Start ***********************************`);
		const gasEstimate = await OrdersManager_instance.estimateGas.checkStopOrders();
		const gasPremium = gasEstimate.mul(130).div(100);
		console.log(`checkStopOrders => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

		try {
			const tx_checkStopOrders =  await OrdersManager_instance.checkStopOrders({ gasLimit: gasPremium });
			const receipt = await tx_checkStopOrders.wait();
			if (receipt.status === false) {
				throw new Error("Transaction checkStopOrders failed");
			}
			console.log(`*********************  checkStopOrders End ***********************************`);
			resolve(`***  checkStopOrders End ***`);
		}
		catch (e) {
			console.log(` ********** while  checkStopOrders an error occured ********** Error: `,e);
			resolve(` *** while  checkStopOrders an error occured *** `);
		}
	});

}
const checkBracketOrders = async () => {
	return new Promise (async (resolve,reject) => {

		console.log(`*********************  checkBracketOrders Start ***********************************`);
		const gasEstimate = await OrdersManager_instance.estimateGas.checkBracketOrders();
		const gasPremium = gasEstimate.mul(130).div(100);
		console.log(`checkBracketOrders => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

		try {
			const tx_checkBracketOrders =  await OrdersManager_instance.checkBracketOrders({ gasLimit: gasPremium });
			const receipt = await tx_checkBracketOrders.wait();
			if (receipt.status === false) {
			throw new Error("Transaction checkBracketOrders failed");
			}
			console.log(`*********************  checkBracketOrders End ***********************************`);
			resolve(`***  checkBracketOrders End ***`);
		}
		catch (e) {
			console.log(` ********** while  checkBracketOrders an error occured ********** Error: `,e);
			resolve(` *** while  checkBracketOrders an error occured *** `);
		}
	});

}
const checkDCAOrders = async () => {
	return new Promise (async (resolve,reject) => {

		console.log(`*********************  checkDCAOrders Start ***********************************`);
		const gasEstimate = await OrdersManager_instance.estimateGas.checkDCAOrders();
		const gasPremium = gasEstimate.mul(130).div(100);
		console.log(`checkDCAOrders => gasEstimate: ${gasEstimate} gasPremium: ${gasPremium}`);

		try {
			const tx_checkDCAOrders =  await OrdersManager_instance.checkDCAOrders({ gasLimit: gasPremium });
			const receipt = await tx_checkDCAOrders.wait();
			if (receipt.status === false) {
			throw new Error("Transaction checkDCAOrders failed");
			}
			console.log(` => checkDCAOrders has updated successfuly at ${new Date()}`);
			resolve(`***  checkDCAOrders End ***`);
		}
		catch (e) {
			console.log(` ********** while  checkDCAOrders an error occured ********** Error: `,e);
			resolve(` *** while  checkDCAOrders an error occured *** `);
		}
	});

}


// ====>
const executeORDERSMoonbeam = async () => {
	return new Promise (async (resolve,reject) => {

		console.log(`*********************  executeORDERSMoonbeam Start ***********************************`);
		try {
			const pendingOrders_FANTOM =  await ExecutionOrdersEngineFantom_instance.get_pendingOrders_FANTOM();
			for (let i=0; i<pendingOrders_FANTOM.length; i++) console.log(`* pendingOrders_FANTOM[${i}]: ${pendingOrders_FANTOM[i]}`);
			
		
			for (let i=0; i<pendingOrders_FANTOM.length; i++)
			{
				const orderNonce = pendingOrders_FANTOM[i];
				console.log(`********************* Will execute Moonbeam Order with nonce: ${orderNonce}`);
				const message = await execute_Order_Fantom(orderNonce);
				console.log(`********************* Executed Moonbeam Order with nonce: ${orderNonce} message: `,message);
			}
			resolve(`***  executeORDERSMoonbeam End ***`);
		}
		catch (e) {
			console.log(` ********** while  executeORDERSMoonbeam an error occured ********** Error: `,e);
			resolve(`***  while  executeORDERSMoonbeam an error occured ***`);

		}
		console.log(`*********************  executeORDERSMoonbeam End ***********************************`);
	});

}

const execute_Order_Fantom = async (orderNonce) => {
	return new Promise (async (resolve,reject) => {

		console.log(`*********************  execute_Order_Fantom Start ***********************************`);
		const gasEstimate = await ExecutionOrdersEngineFantom_instance.estimateGas.executeOrder_Fantom( orderNonce ); 
		const gasPremium = gasEstimate.mul(130).div(100);
		console.log(`gasEstimate: ${gasEstimate} gasPremium: ${gasPremium} orderNonce: ${orderNonce}`);

		try {
			const tx_execute_Order_Fantom =  await ExecutionOrdersEngineFantom_instance.executeOrder_Fantom(orderNonce, { gasLimit: gasPremium });
			const receipt = await tx_execute_Order_Fantom.wait();
			if (receipt.status === false) {
				throw new Error(`Transaction execute_Order_Fantom with orderNonce: ${orderNonce} failed`);
			}
			console.log(`*********************  execute_Order_Fantom End ***********************************`);
			resolve(`Transaction execute_Order_Fantom with orderNonce: ${orderNonce} succeeded`);
		}
		catch (e) {
			console.log(` ********** while  execute_Order_Fantom an error occured ********** Error: `,e);
			resolve(e);
		}
	});

}



//#region ***** getBalanceForBINANCEaccount //*****
const getBalanceForBINANCEaccount = async (tokenAddress, client, decimals=18) => {
	const balanceWEI = await ExecutionOrdersEngineFromBinance_instance.userBalance(client,tokenAddress);
	const balance = ethers.utils.formatUnits(balanceWEI,decimals);
	// console.log(`Balnance of ${client} for ${tokenAddress} is: `,balance);
	return Number(balance).toFixed(5);
};
//#endregion

//#region ***** getBalanceForMOONBEAMaccount //*****
const getBalanceForMOONBEAMaccount = async (tokenAddress, client, decimals=18) => {
	const balanceWEI = await ExecutionOrdersEngineFromMoonbeam_instance.userBalance(client,tokenAddress);
	const balance = ethers.utils.formatUnits(balanceWEI,decimals);
	// console.log(`Balnance of ${client} for ${tokenAddress} is: `,balance);
	return Number(balance).toFixed(5);
};
//#endregion

//#region ***** Get balance for ERC20 token //*****
const getBalance = async (tokenAddress, client, _wallet, decimals=18) => {
	// console.log(`getBalance => tokenAddress: ${tokenAddress} client: ${client} _wallet: `,_wallet);
	const erc20 =  new ethers.Contract( tokenAddress, IERC20_raw.abi, _wallet);
	const balanceWEI = await erc20.balanceOf(client);
	const balance = ethers.utils.formatUnits(balanceWEI,decimals);
	// console.log(`Balnance of ${client} for ${tokenAddress} is: `,balance);
	return Number(balance).toFixed(5);
};
//#endregion

//#region ***** Simple ERC20 Transfer //*****
const simpleERC20Transfer = async (wallet, tokenAddress, receipient, amountin_unitsEth="0.001") => {
	const erc20 =  new ethers.Contract( tokenAddress, IERC20_raw.abi, wallet);
  
	const amountWEI =  ethers.BigNumber.from( ethers.utils.parseUnits(amountin_unitsEth,12) );
	const tx3 = await erc20.transfer(receipient, amountWEI);
	tx3.wait().then( async reslveMsg => {
	//   console.log(`tx3 for transfer is mined resolveMsg : `,reslveMsg);
	 });
};
//#endregion




export {

		setWallet,
		simpleERC20Transfer,
		getBalance,

		setChainOfUser,
		getUserChain,
		registerUser_Fantom,
		get_OrderBooks,
		get_ExecutionsPendingOrderBook_Fantom,
		get_SpookySwap_Prices,
		get_Fantom_Balances,

		submitOrder_Fantom,
		deleteOrder_Fantom,
		checkLimitOrders,
		checkStopOrders,
		checkBracketOrders,
		checkDCAOrders,
		update_SpookySwap_Prices,
		executeORDERSMoonbeam,
		getBalanceForBINANCEaccount,
	};